import Service from './Service'
import { LEAD } from './apiUrls'

export default class LeadService extends Service {
  postComment (id, data) {
    return this.axios.post(`${LEAD}/${id}/comments`, data)
  }
  patchComment (id, data) {
    return this.axios.patch(`${LEAD}/${id}/comments/${data.uuid}`, data)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/LeadService.js